import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Check, Copy } from "lucide-react";
import { base_url } from "../../config";
import axios from "axios";
import {
  darkBodyCellSx,
  darkHeadCellSx,
  darkPaperSx,
  darkRowSx,
  darkSearchSx,
  darkToolbarSx,
} from "./darkTable";

type Row = { code: string; name: string; email: string };

const Assigned = () => {
  const [data, setData] = useState<Row[]>([]);
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    axios
      .get(`${base_url}/api/admin/get-codes/assigned`)
      .then((response) => setData(response.data))
      .catch((error) => console.error("Error fetching codes:", error));
  }, []);

  const handleCopy = (code: string) => {
    navigator.clipboard.writeText(code);
    setCopied(code);
    setTimeout(() => setCopied(null), 1200);
  };

  const columns = [
    {
      accessorKey: "code",
      header: "Code",
      Cell: ({ row }: { row: { original: Row } }) => (
        <div className="flex items-center gap-2">
          <span className="font-mono text-[11px] px-2 py-0.5 rounded-md bg-slate-700/40 text-slate-100 border border-slate-600/40">
            {row.original.code}
          </span>
          <button
            onClick={() => handleCopy(row.original.code)}
            className="inline-flex items-center justify-center h-6 w-6 rounded text-slate-400 hover:text-blue-300 hover:bg-blue-500/10 transition-colors"
            title="Copy"
          >
            {copied === row.original.code ? (
              <Check className="h-3.5 w-3.5 text-emerald-300" />
            ) : (
              <Copy className="h-3.5 w-3.5" />
            )}
          </button>
        </div>
      ),
    },
    {
      accessorKey: "name",
      header: "Name",
      Cell: ({ row }: { row: { original: Row } }) => (
        <span className="text-slate-100">{row.original.name}</span>
      ),
    },
    {
      accessorKey: "email",
      header: "Email",
      Cell: ({ row }: { row: { original: Row } }) => (
        <span className="text-slate-400 text-xs">{row.original.email}</span>
      ),
    },
  ];

  return (
    <div className="rounded-2xl overflow-hidden">
      <MaterialReactTable
        columns={columns}
        data={data}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableHiding={false}
        initialState={{ density: "compact", pagination: { pageSize: 25, pageIndex: 0 } }}
        muiTablePaperProps={{ sx: darkPaperSx }}
        muiTableContainerProps={{ sx: { backgroundColor: "transparent" } }}
        muiTopToolbarProps={{ sx: darkToolbarSx }}
        muiBottomToolbarProps={{ sx: darkToolbarSx }}
        muiTableHeadCellProps={{ sx: darkHeadCellSx }}
        muiTableBodyCellProps={{ sx: darkBodyCellSx }}
        muiTableBodyRowProps={{ sx: darkRowSx }}
        muiSearchTextFieldProps={{ placeholder: "Search…", sx: darkSearchSx }}
      />
    </div>
  );
};

export default Assigned;
